import React from "react";
import { StyledText } from "../../../../components/common";
import styled from "styled-components";
import { useTheme } from "../../../../hooks";

const VotingStatusCard = ({
  numberOfVotes,
  imgUrl,
  teamName,
  width,
  votePercent,
}) => {
  const { themeContext, theme } = useTheme();

  let themeColor = "background";
  let background = theme.colors[themeContext.activeTheme][themeColor];
  return (
    <Container>
      <StyledText style={{ fontSize: 13 }}>{teamName}</StyledText>
      <div style={{ display: "flex", alignItems: "center" }}>
        <img
          width={50}
          height={50}
          style={{ borderRadius: 300 }}
          src={imgUrl}
          alt="Winners Image"
        />
        <div style={{ display: "flex" }}>
          <div
            style={{
              height: 50,
              width: width/100 * 200,
              backgroundColor: background,
              marginInline: 20,
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              color: "white",
              paddingInline: 10,
            }}
          >
            {votePercent}%
          </div>
          <StyledText
            style={{ color: "#7F7F7F", fontFamily: "MTNRegular", fontSize: 12 }}
          >
            {numberOfVotes} Votes
          </StyledText>
        </div>
      </div>
    </Container>
  );
};

export default VotingStatusCard;

const Container = styled.div`
  align-items: center;
`;
